export default __webpack_public_path__ + "static/media/payment-stripe.c63d74f3.svg";